import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ChainedBackend, { ChainedBackendOptions } from 'i18next-chained-backend';

import { getDefaultI18nOptions } from './backendOptions';

type Payload = Parameters<typeof getDefaultI18nOptions>[0];

/**
 * 클라이언트 전용 i18next 부팅(play·dashboard). 언어 감지 → HTTP 백엔드(`?version=` 캐시 키)
 * → react-i18next 순으로 플러그인을 꽂고 init 한다. 브라우저에서만 부른다.
 */
export const createClientI18n = (payload: Payload) =>
  i18next
    .use(LanguageDetector)
    .use(ChainedBackend)
    .use(initReactI18next)
    .init<ChainedBackendOptions>(getDefaultI18nOptions(payload))
    .catch((error: unknown) => {
      console.error('[i18n] init failed', error);
    });
